import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Ecommerce from "../../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../../images/services/cto/RealEstate.svg";
import Healthcare from "../../../images/services/cto/Healthcare.svg";
import Food from "../../../images/services/cto/Food.svg";
import Lifestyle from "../../../images/services/cto/lifestyle.svg";
import Gaming from "../../../images/services/cto/Gaming.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Techsolution(props) {
    return (
        <div className="p-100 tekrevol_gray_bg">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={7} xxl={7}>
                        <div className="example" data-text="Industries">
                            <h2>Industries we serve</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="tech_bg">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tech_tabs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Healthcare}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Healthcare
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>POS Systems in the healthcare industry allow more freedom to patients and help
                                        bridge the gap between the demand and supply of services. TekRevol has helped
                                        healthcare organizations build and deploy customized POS systems reshaping their
                                        inpatient and outpatient care, and recreated the in-hospital and telemedicine
                                        payment service for patients with a solution that generates invoices, processes
                                        insurance claims, loyalty points, and discounts in real-time – during routine
                                        visits as well as emergency cases.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={RealEstate}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Real Estate
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>In the real estate domain, POS systems can significantly help realtors and
                                        tenants keep track of their rental properties, residential houses, and
                                        commercial offices listed for sale. They can also offer integrated payment
                                        solutions for collecting rent, utilities, brokerage, and commissions. </p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Gaming}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Gaming
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Gaming companies and game entrepreneurs, especially those working with digital
                                        entities that monetize through in-app purchases and digital downloads, have
                                        ideal use cases for integrated POS systems. TekRevol’s customizable POS
                                        solutions can help such entrepreneurs automate their digital invoicing. </p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Ecommerce}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Ecommerce
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>For startups and established ecommerce businesses, retail stores, and online
                                        sellers, TekRevol can create integrated Point of Sale solutions that bring
                                        inventories, analytics, and conversions to one digital dashboard. Keep track of
                                        your stock, leads, daily to yearly payments, revenues and ratios, and financial
                                        health of the stakeholder side of the business. </p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Lifestyle}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Lifestyle
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>In the lifestyle niche, POS systems have innumerable transformative use cases for
                                        businesses selling products, providing services, or capitalizing on
                                        informational content. From real-time inventory and SKU updates to online
                                        invoicing and payment, an integrated POS system can reshape the online and
                                        in-shop customer experience.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Food}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Food
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Take data from your cloud kitchen to invoicing of the Quick Service Restaurants;
                                        TekRevol has built integrated POS solutions with seamless Restaurant Management
                                        Systems that work together to automate food businesses. From on-table systems to
                                        order tracking to payment automation to discount applications, we offer
                                        all-in-one solutions tailored for entrepreneurs in the food and beverage
                                        industry.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Techsolution;